import { SerializedStyles, css, keyframes } from "@emotion/react";
import { lighten } from "polished";

export const shine = keyframes`
  0% {
    background-position: 100% 50%;
  }

  100% {
    background-position: 0 50%;
  }
`;

export const loadingAnimation = (color = "#dde2e6", lightenAmount = 0.05): SerializedStyles => css`
  background-image: linear-gradient(
    90deg,
    ${lighten(lightenAmount, color)} 25%,
    ${color} 37%,
    ${lighten(lightenAmount, color)} 63%
  );
  animation: ${shine} 1.4s ease infinite;
  background-size: 400% 100%;
`;
